function Footer() {
  return (
    <footer className='footer p-5 shadow-lg bg-neutral text-neutral-content text-primary-content footer-center text-white'>
        <div>
            Made with 🤍 in React+Tailwind
        </div>
    </footer>
  )
}

export default Footer